import React, { useState, useEffect, useContext } from 'react';
import { db } from '../firebaseConfig.js';
import { collection, getDocs, updateDoc, doc, query, where, getDoc } from 'firebase/firestore';
import { AuthContext } from '../context/AuthContext.js'; 
import ContractedProfessionals from './ContractedProfessionals.js';
import SolicitudPuntuacion from './SolicitudPuntuacion.js';

const SentRequest = () => {
  const [requests, setRequests] = useState([]);
  const [modalData, setModalData] = useState({ isVisible: false, professional: null, successMessage: false });
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const { currentUser } = useContext(AuthContext); 

  useEffect(() => {
    const fetchRequests = async () => {
      if (!currentUser) return; // Verifica si el usuario está autenticado

      try {
        const solicitudesRef = collection(db, 'solicitudservicios');
        const q = query(
          solicitudesRef,
          where('estado', '==', 'pendiente'),
          where('uid', '==', currentUser.uid) // Filtrar por uid del usuario autenticado
        );
        const solicitudesSnapshot = await getDocs(q);

        const solicitudesData = await Promise.all(
          solicitudesSnapshot.docs.map(async (doc) => {
            const responsesRef = collection(doc.ref, 'profesionales');
            const responsesSnapshot = await getDocs(responsesRef);

            const responses = responsesSnapshot.docs.map((responseDoc) => ({
              ...responseDoc.data(),
              uid: responseDoc.id,
            }));

            return { id: doc.id, ...doc.data(), responses };
          })
        );

        setRequests(solicitudesData);
      } catch (error) {
        console.error('Error al obtener solicitudes:', error);
      }
    };

    fetchRequests();
  }, [currentUser]);

  const openModal = async (professional, requestId) => {
    try {
      const userDocRef = doc(db, 'users', professional.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        setModalData({
          isVisible: true,
          professional: { ...userDoc.data(), uid: professional.uid },
          successMessage: false,
        });
        setSelectedRequestId(requestId);
      } else {
        console.error('No se encontró al profesional.');
      }
    } catch (error) {
      console.error('Error al obtener datos del profesional:', error);
    }
  };

  const closeModal = () => {
    setModalData({ isVisible: false, professional: null, successMessage: false });
    setSelectedRequestId(null);
  };

  const handleAcceptBudget = async () => {
    const { professional } = modalData;

    if (!selectedRequestId || !professional || !professional.uid) {
      console.error('Falta información para aceptar el presupuesto.');
      return;
    }

    try {
      const requestRef = doc(db, 'solicitudservicios', selectedRequestId);
      await updateDoc(requestRef, {
        asignado: professional.uid,
        estado: 'asignado',
      });

      setModalData((prev) => ({ ...prev, successMessage: true }));
    } catch (error) {
      console.error('Error al aceptar presupuesto:', error);
      alert('Error al aceptar el presupuesto.');
    }
  };

  return (
    <div>
      <h2>Solicitudes enviadas</h2>
      <table className="requests-table">
        <thead>
          <tr>
            <th>Categoría</th>
            <th>Respuestas</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr key={request.id}>
              <td>{request.category}</td>
              <td>
                {request.responses.length > 0 ? (
                  <ul>
                    {request.responses.slice(0, 5).map((response, index) => (
                      <li
                        key={index}
                        onClick={() => openModal(response, request.id)}
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                      >
                        {response.presupuesto ? `Presupuesto: $${response.presupuesto}` : 'Sin detalles'}
                      </li>
                    ))}
                  </ul>
                ) : (
                  'Sin respuestas'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalData.isVisible && modalData.professional && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Detalles del profesional</h3>
            <p><strong>Nombre:</strong> {modalData.professional.fullName}</p>
            <p><strong>Puntuación:</strong>{' '}
              {modalData.professional.promedioPuntuacion ? (
                <>
                 {parseFloat(modalData.professional.promedioPuntuacion).toFixed(2)}{' '}
                 <i className="fas fa-star" style={{ color: 'gold' }}></i>
                </>
              ) : (
                'No disponible'
              )}
            </p>
            <p><strong>Descripción:</strong> {modalData.professional.description}</p>
            <p><strong>Experiencia:</strong> {modalData.professional.experience}</p>
            {modalData.professional.imgprof && (
              <div>
                {modalData.professional.imgprof.fileName.endsWith('.mp4') || modalData.professional.imgprof.fileName.endsWith('.avi') ? (
                  <video controls style={{ maxHeight: '450px', maxWidth: '100%', margin: '0 auto' }}>
                    <source src={modalData.professional.imgprof.fileURL} type="video/mp4" />
                    Tu navegador no soporta el elemento de video.
                  </video>
                ) : (
                  <img src={modalData.professional.imgprof.fileURL} alt="Imagen del profesional" style={{ maxHeight: '450px', maxWidth: '100%', margin: '0 auto' }} />
                )}
              </div>
            )}
            {modalData.successMessage ? (
              <>
                <p className="success-message">¡Presupuesto aceptado correctamente!</p>
                <p>
                  <strong>Teléfono:</strong>{' '}
                  <a
                    href={`https://wa.me/${modalData.professional.phone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline', color: 'blue' }}
                  >
                    {modalData.professional.phoneNumber}
                  </a>
                </p>
                <p><strong>Email:</strong> {modalData.professional.email}</p>
              </>
            ) : (
              <div className="modal-actions">
                <button onClick={handleAcceptBudget}>Aceptar presupuesto</button>
                <div><small>Acepta el presupuesto para ponerte en contacto con el profesional</small></div>
              </div>
            )}
            <button onClick={closeModal} className="btn-cerrar">Cerrar</button>
          </div>
        </div>
      )}

      <div className="ContenedorSF">
        <SolicitudPuntuacion />
      </div>

      <div className="ContenedorPC">
        <ContractedProfessionals />
      </div>
      
    </div>
  );
};

export default SentRequest;
